<script>
import Layout from '@layout/main'
import SectionSecondary from './components/SectionSecondary'
import SectionFeatures from './components/SectionFeatures'
// import SectionList from './components/SectionList'
import SectionContact from './components/SectionContact'
import SectionInterFeatures from './components/SectionInterFeatures'
import SectionInterList from './components/SectionInterList'

export default {
  page() {
    return {
      title: '預約系統方案',
    }
  },
  components: {
    Layout,
    SectionSecondary,
    SectionFeatures,
    // SectionList,
    SectionContact,
    SectionInterFeatures,
    SectionInterList
  },
}
</script>
<template>
  <Layout>
    <div class="header__bg">
      <BaseBannerTitle 
        title="預約系統方案" 
        sub-title="Reservation System"
      />
    </div>
    <SectionFeatures/>
    <SectionSecondary/>
    <div class="container block">
      <BaseBlock 
        title="進階的預約系統方案，當然會是您更好的選擇"
        content="精確的數據分析與線上付款的功能，絕對會為您創造效益極大化"
      />
    </div>
    <!-- <SectionList/> -->
    <SectionInterFeatures />
    <SectionInterList />
    <SectionContact/>
  </Layout>
</template>
<style lang="scss" scoped>
  .block {
    margin-top: 15rem;
    @include max-lg {
      margin-top: 0;
    }
  }
</style>